import styles from "./Explanation.module.scss";

const Explanation = ({ children, is_caution = false, sectionClass = " " }) => {
  return (
    <section className={sectionClass}>
      <h2 className={styles.explanation}>
        {is_caution ? (
          <span className={styles.caution}>{children}</span>
        ) : (
          children
        )}
      </h2>
    </section>
  );
};
export default Explanation;
